var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCockpit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.1406142%",
    y1: "20.1284775%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cockpit",
    transform: "translate(-28.000000, -438.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.000000, 426.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cockpit",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#263238",
    strokeWidth: 2,
    cx: 12,
    cy: 12,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0513167,15.3162278 L7.8973666,17.3675445 C7.37342328,17.5421922 6.8071033,17.2590323 6.63245553,16.7350889 C6.56403326,16.5298221 6.56403326,16.3079002 6.63245553,16.1026334 L8.68377223,9.9486833 C8.88284223,9.3514733 9.3514733,8.88284223 9.9486833,8.68377223 L16.1026334,6.63245553 C16.6265767,6.45780776 17.1928967,6.74096775 17.3675445,7.26491106 C17.4359667,7.47017787 17.4359667,7.69209979 17.3675445,7.8973666 L15.3162278,14.0513167 C15.1171578,14.6485267 14.6485267,15.1171578 14.0513167,15.3162278 Z",
    id: "Path",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 12,
    cy: 12,
    r: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCockpit);
export default __webpack_public_path__ + "static/media/cockpit.181fd4f5f618ddfcb42a218a26569393.svg";
export { ForwardRef as ReactComponent };